module.exports = __webpack_public_path__ + "static/media/botones-10.e64feeb2.png";